import { render } from "./Stylesguide.vue?vue&type=template&id=5a6aa565&scoped=true"
import script from "./Stylesguide.vue?vue&type=script&lang=js"
export * from "./Stylesguide.vue?vue&type=script&lang=js"

import "./Stylesguide.vue?vue&type=style&index=0&id=5a6aa565&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6aa565"]])

export default __exports__